import React, {Component} from 'react';
import styled from 'styled-components';

const Row = styled.div`
  >*{
    &:first-child{
      .cartColumn__header{
        &:after{
          left: 0;
        }
      }
    }
    &:last-child{
      .cartColumn__header{
        &:after{
          right: 0;
        }
      }
    }
  }
`;

class CartRow extends Component {
    render() {
        return (
            <Row className={'row'}>
                {this.props.children}
            </Row>
        );
    }
}

export default CartRow